import { render, staticRenderFns } from "./TransactionsPurchasesSearch.vue?vue&type=template&id=8f1f01d6"
import script from "./TransactionsPurchasesSearch.vue?vue&type=script&lang=js"
export * from "./TransactionsPurchasesSearch.vue?vue&type=script&lang=js"
import style0 from "./TransactionsPurchasesSearch.vue?vue&type=style&index=0&id=8f1f01d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports